import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { map, switchMap } from 'rxjs/operators';
import { TextService } from './text.service';

@Injectable({
  providedIn: 'root',
})
export class TableConfigService {
  labels = {};
  localeId: string;
  constructor(
    private restApi: RequestService,
    private textService: TextService
  ) {}

  load(tableId: string) {
    return this.restApi
      .request('GET', '/api/v5/app-table-designs', { 'name.equals': tableId })
      .pipe(
        map((res: any) => {
          if (!res.body) return null;

          const tableConfig = JSON.parse(res.body[0].tableDefination);
          return tableConfig;
        })
      );
  }

  loadTranslated(
    tableId: string,
    translateOption = {
      convertKeyValue: {
        labelId: 'label',
      },
    }
  ) {
    return this.load(tableId).pipe(
      switchMap((tableConfig) =>
        this.textService.convert(tableConfig.tableCols, translateOption)
      )
    );
  }

  applyLabel(cols) {
    return cols.map((col) => {
      col.header = this.labels
        ? this.labels['data'][col.labelId]?.value
        : col.labelId;
      return col;
    });
  }
}
